// سدر الخليج: سطر الفحم، وما يقرّب الطلب من الشحن المجاني في السلة (STR-144). الشرح في snippets/sedr-cart-suggest.liquid
(() => {
  if (window.sedrCartSuggest) return;
  window.sedrCartSuggest = true;

  // سطر الفحم: الإغلاق باقٍ على <html> لأن ترقيع الدرج لا يمسه
  const coalKey = 'sedr-coal-hint-off';
  try { if (localStorage.getItem(coalKey)) document.documentElement.classList.add('sedr-coal-off'); } catch (error) {}
  document.addEventListener('click', (event) => {
    const close = event.target.closest('[data-sedr-coal-close]');
    if (!close) return;
    const hint = close.closest('.sedr-coal-hint');
    const scope = hint.closest('.cart-drawer__inner, .cart') || document.body;
    const focusable = [...scope.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), [tabindex]:not([tabindex="-1"])')];
    const next = focusable.find((node) => !hint.contains(node) && (hint.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_FOLLOWING));
    document.documentElement.classList.add('sedr-coal-off');
    try { localStorage.setItem(coalKey, '1'); } catch (error) {}
    next?.focus();
  });

  // أقرب إلى الشحن المجاني: توصيات كل منتج تُجلب مرة في الصفحة
  const cache = new Map();
  const load = (url, id) => {
    if (!cache.has(id)) {
      cache.set(id, fetch(`${url}?product_id=${id}&limit=10&intent=related&section_id=sedr-cart-suggest`)
        .then((response) => response.ok ? response.text() : '')
        .then((html) => [...new DOMParser().parseFromString(html, 'text/html').querySelectorAll('[data-sedr-suggest]')])
        .catch(() => []));
    }
    return cache.get(id);
  };

  class SedrCartSuggest extends HTMLElement {
    connectedCallback() {
      this._observer = new MutationObserver(() => this._render());
      this._observer.observe(this, { attributes: true, childList: true });
      this._render();
    }

    disconnectedCallback() {
      this._observer?.disconnect();
    }

    async _render() {
      const anchors = (this.getAttribute('anchors') || '').split(',').filter(Boolean);
      const exclude = new Set((this.getAttribute('exclude') || '').split(','));
      const gap = Number(this.getAttribute('gap'));
      const signature = [anchors, [...exclude], gap].join('|');

      // ما رُسم لهذه الحالة نفسها باقٍ: لا يُعاد
      if (this._signature === signature && this.firstElementChild?.dataset.signature === signature) return;
      this._signature = signature;

      const lists = await Promise.all(anchors.map((id) => load(this.getAttribute('url'), id)));
      if (this._signature !== signature) return;

      const seen = new Set();
      const picks = lists.flat().filter((item) => {
        const handle = item.dataset.handle, price = Number(item.dataset.price);
        if (seen.has(handle) || exclude.has(handle) || price < gap || price > gap + 3000) return false;
        seen.add(handle);
        return true;
      }).slice(0, 2);

      if (!picks.length) {
        if (this.firstChild) this.replaceChildren();
        return;
      }

      // الدرج يُرسم في صفحة السلة أيضًا: لاحقة لكل معرّف حتى لا يتكرر بين النسختين
      const suffix = this.closest('.shopify-section')?.id || 'sedr';
      const cards = picks.map((item) => {
        const card = document.importNode(item.firstElementChild, true);
        card.querySelectorAll('[id]').forEach((node) => { node.id += `-${suffix}`; });
        card.querySelectorAll('[aria-controls], [form]').forEach((node) => {
          ['aria-controls', 'form'].forEach((name) => node.hasAttribute(name) && node.setAttribute(name, `${node.getAttribute(name)}-${suffix}`));
        });
        return card;
      });

      const wrapper = document.createElement('div');
      wrapper.className = 'sedr-suggest';
      wrapper.dataset.signature = signature;
      const heading = document.createElement('p');
      heading.className = 'text-sm';
      heading.textContent = this.getAttribute('heading');
      const list = document.createElement('div');
      list.className = 'sedr-suggest__list';
      list.append(...cards);
      wrapper.append(heading, list);
      this.replaceChildren(wrapper);
    }
  }

  if (!customElements.get('sedr-cart-suggest')) customElements.define('sedr-cart-suggest', SedrCartSuggest);
})();
